<template>
    <span
    v-if="statusClasses[status as keyof typeof statusClasses]"
    :class="[
        'inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-medium',
        statusClasses[status as keyof typeof statusClasses],
    ]"
    >
        <span class="relative flex h-2 w-2">
            <span
            :class="[
                'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
                statusClasses[status as keyof typeof statusClasses].split(' ')[0],
            ]"
            ></span>
            <span
            :class="[
                'relative inline-flex h-2 w-2 rounded-full',
                statusClasses[status as keyof typeof statusClasses].split(' ')[0],
            ]"
            ></span>
        </span>
        {{ statusLabels[status as keyof typeof statusLabels] }}
    </span>
</template>

<script setup lang="ts">
const statusClasses = {
    active: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
    // inactive: 'bg-zinc-400 text-zinc-50 bg-zinc-400/10',
    inactive: 'bg-red-500 text-red-50 bg-red-500/10',
    error: 'bg-red-500 text-red-50 bg-red-500/10',
    hidden: 'bg-indigo-500 text-indigo-50 bg-indigo-500/10',
}
const statusLabels = {
    active: 'Ativo',
    inactive: 'Inativo',
    error: 'Erro',
    hidden: 'Oculto',
}
defineProps<{
    status: any
}>()
</script>

